import type { PiniaPluginContext } from 'pinia'

/**
 * Pinia 状态管理日志插件
 * 用于在开发环境下监控 Pinia store 的状态变化和 action 执行
 * 所有日志信息均以中文显示，便于开发调试
 */
export function piniaLogger({ store }: PiniaPluginContext) {
    // 监听状态变化
    store.$subscribe((mutation, state) => {
        const prevState = { ...store.$state }

        // 使用普通文本格式，确保在所有环境下都能正常显示
        console.groupCollapsed(`[Pinia状态变化] ${mutation.storeId} ${mutation.type}`)
        console.log('之前状态:', prevState)
        console.log('状态变更:', mutation)
        console.log('当前状态:', state)
        console.groupEnd()
    })

    // 监听 action 执行
    store.$onAction(({ name, args, after, onError }) => {
        console.groupCollapsed(`[Pinia动作执行] ${store.$id}/${name}`)
        console.log('参数:', args)

        // 动作执行完成后的回调
        after((result) => {
            console.log('执行结果:', result)
            console.groupEnd()
        })

        // 动作执行出错时的回调
        onError((error) => {
            console.error('执行错误:', error)
            console.groupEnd()
        })
    })
}
